if (!customElements.get('aurviq-navigation')) {
  customElements.define('aurviq-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-menu-open]');
      trigger.addEventListener('click', () => { dialog.showModal(); trigger.setAttribute('aria-expanded', 'true'); }, { signal });
      this.querySelector('[data-menu-close]').addEventListener('click', () => dialog.close(), { signal });
      dialog.addEventListener('close', () => trigger.setAttribute('aria-expanded', 'false'), { signal });
      dialog.addEventListener('click', event => {
        if (event.target.closest('a')) dialog.close();
        if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX > r.right || event.clientX < r.left) dialog.close(); }
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
if (!customElements.get('aurviq-product')) {
  customElements.define('aurviq-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const signal = this.controller.signal;
      const main = this.querySelector('.aq-gallery-image');
      const thumbs = [...this.querySelectorAll('[data-gallery-src]')];
      const showImage = (src, alt) => { main.removeAttribute('srcset'); main.src = src; if (alt) main.alt = alt; };
      thumbs.forEach(thumb => thumb.addEventListener('click', () => {
        showImage(thumb.dataset.gallerySrc, thumb.querySelector('img')?.alt);
        thumbs.forEach(t => t.setAttribute('aria-pressed', String(t === thumb)));
      }, { signal }));
      const lightbox = this.querySelector('.aq-lightbox');
      this.querySelector('[data-zoom]').addEventListener('click', () => { lightbox.querySelector('img').src = main.currentSrc || main.src; lightbox.querySelector('img').alt = main.alt; lightbox.showModal(); }, { signal });
      this.querySelector('[data-zoom-close]').addEventListener('click', () => lightbox.close(), { signal });
      lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); }, { signal });
      const select = this.querySelector('[data-variant-select]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        this.querySelector('[data-price]').textContent = option.dataset.price;
        this.querySelector('[data-sticky-price]').textContent = option.dataset.price;
        const available = option.dataset.available === 'true';
        this.querySelector('button[name="add"]').disabled = !available;
        this.querySelector('[data-add-text]').textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        if (option.dataset.image) { showImage(option.dataset.image); thumbs.forEach(t => t.setAttribute('aria-pressed', String(t.dataset.gallerySrc === option.dataset.image))); }
      }, { signal });
      this.observer?.disconnect();
      const sticky = this.querySelector('.aq-sticky-buy');
      this.observer = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, { threshold: 0 });
      this.observer.observe(this.querySelector('.aq-buy-panel'));
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
function revealContactResult() {
  const contact = document.querySelector('.aq-contact-details');
  if (contact && (location.hash === '#AurviqContact' || contact.querySelector('[role="status"], .errors'))) contact.open = true;
}
document.addEventListener('DOMContentLoaded', revealContactResult);
